import { getFilterGroupCreatedId } from 'data/filterGroup/filterGroup.selectors';
import { FilterGroupUpdateCallback } from 'data/template/template.types';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldUpdateHandlerParam } from 'shared/form';
import { FilterGroup } from 'data/filterGroup/filterGroup.types';
import { openFilterGroupCreatePopup } from 'data/filterGroup/filterGroup.actions';

// eslint-disable-next-line import/prefer-default-export
export function useFieldCreateNewFilterGroup(
  handleFieldUpdate: FilterGroupUpdateCallback,
): [FilterGroupUpdateCallback] {
  const idCreated = useSelector(getFilterGroupCreatedId);
  const dispatch = useDispatch();
  const paramRef = useRef<FieldUpdateHandlerParam>();

  useEffect(() => {
    if (idCreated == null || paramRef.current == null) {
      return;
    }

    const param = paramRef.current;
    if (param == null) {
      return;
    }

    paramRef.current = undefined;

    param.value = idCreated;
    // The value label may have been changed in the create dialog, so removing it to avoid confusion
    param.valueLabel = null;

    handleFieldUpdate(param);

  }, [idCreated]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFieldCreateNew: FilterGroupUpdateCallback = (param) => {
    const filterGroup: FilterGroup = {
      id: '',
      fgId: param.valueLabel,
      name: '',
      owner: '',
      group: '',
      access: '',
    };
    dispatch(openFilterGroupCreatePopup(filterGroup));

    paramRef.current = param;
  };

  return [handleFieldCreateNew];
}
